// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=14698%3A24670
import { colors } from "./colors";
export var shadows = {
  raised: '0px 1px 4px rgba(0, 0, 0, 0.15)',
  inner: 'inset 0px 0px 4px rgba(0, 0, 0, 0.08)',
  top: '0px 1px 8px rgba(0, 0, 0, 0.15)',
  bottom: '0px -1px 8px rgba(0, 0, 0, 0.15)',
  popOut: '0px 4px 16px rgba(0, 0, 0, 0.15)',
  borderBottom: "inset 0px -1px 0px " + colors.tertiary[500],
  borderTop: "0px -1px 0px " + colors.tertiary[500]
};
//# sourceMappingURL=shadows.js.map